import * as WebBrowser from 'expo-web-browser'
import { observer } from 'mobx-react-lite'
import React, { useCallback, useEffect, useState } from 'react'
import {
  ActivityIndicator,
  Alert,
  BackHandler,
  Linking,
  Platform,
  StatusBar,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View
} from 'react-native'
// import {
//   finishTransaction,
//   promotedProductListener,
//   PurchaseError,
//   purchaseErrorListener,
//   purchaseUpdatedListener,
//   transactionListener
// } from 'react-native-iap'
//import type { TransactionEvent } from 'react-native-iap/lib/typescript/src/types/appleSk2'
import { SafeAreaView } from 'react-native-safe-area-context'

import { AntDesign, MaterialIcons } from '@expo/vector-icons'
import { useFocusEffect, useLocalSearchParams, useRouter } from 'expo-router'

import { DS } from '../../design-system'
import { translate } from '../../i18n'
import { useStore } from '../../models'
import { TabRoutes } from '../../navigation'
import { HomeNavigation, HomeStackParams } from '../../navigation/homeNavigator'
import { capitalizeFirstLetter } from '../../utils/formatString'
import { extendLogger, LoggerContexts } from '../../utils/logger'
//import { usePayment } from '../new-design/hooks'
import { startStyles } from '../sign-up/style'
import { AppleCheckout } from './components/AppleCheckout'
import MembershipCard from './components/MembershipCard'

// type TransactionEvent = any

const isIOS = Platform.OS === 'ios'
const logger = extendLogger(LoggerContexts.Membership)

const JoinPremiumCheckoutScreen = observer(() => {
  const router = useRouter()
  const params = useLocalSearchParams<{ membershipType: string }>()
  const {
    game: { setToast },
    memberships: {
      membershipTypes,
      getPromotionByPromoCode,
      promotionalCode,
      setPromotionalCode,
      activeNewSubscriptionState,
      createAppleSubscription,
      getMySubscription,
      subscription,
      justSubscribed,
      setJustSubscribed
    },
    analytics: { setEvent }
  } = useStore()
  //const { paySubscription, loading: loadingPayment } = usePayment()
  const [coupon, setCoupon] = useState('')
  const [isCouponAdded, setIsCouponAdded] = useState(false)

  const selectedMembership = membershipTypes.find((m) => m.type === params.membershipType)
  const membershipPrice = selectedMembership?.price || 0

  const [currentBasePrice, setCurrentBasePrice] = useState(membershipPrice)
  const parsedValue = (value: number) => {
    return value / 100
  }
  const [loading, setLoading] = useState(false)

  const onCouponChange = (text: string) => {
    setCoupon(text)
  }

  // useEffect(() => {
  //   if (isIOS) {
  //     const purchaseUpdateSubscription = purchaseUpdatedListener(async (purchase) => {
  //       const receipt = purchase.transactionReceipt
  //       // console.log('purchaseUpdatedListener', purchase)
  //       console.log('In purchaseUpdateSubscription')
  //       if (receipt) {
  //         try {
  //           await getMySubscription()
  //           if (subscription) {
  //             await finishTransaction({ purchase })
  //           }
  //         } catch (ackErr) {
  //           console.log('There was an error in purchaseUpdateSubscription', ackErr)
  //           // console.log('purchaseUpdatedListener ackErr', ackErr)
  //         }
  //       } else {
  //         // console.log('purchaseUpdatedListener error: receipt')
  //       }
  //     })

  //     // @ts-ignore
  //     const promotedProductSubscription = promotedProductListener(async (productId) => {
  //       logger.info('promotedProductListener', productId)
  //     })

  //     const transactionSubscription = transactionListener((transactionEvent: TransactionEvent) => {
  //       const { transaction, error } = transactionEvent
  //       if (error) {
  //         // console.error('transactionListener', error)
  //         logger.error('transactionListener', error)
  //         return
  //       }
  //       // console.log('transactionListener', transaction)
  //       console.log('transactionListener')
  //       if (transaction?.verificationResult) {
  //         // finalizeAppleSubscription()
  //       }
  //     })

  //     const purchaseErrorSubscription = purchaseErrorListener((error: PurchaseError) => {
  //       logger.error('purchaseErrorListener', error)
  //     })

  //     return () => {
  //       // appStateListener.remove()
  //       purchaseUpdateSubscription.remove()
  //       promotedProductSubscription?.remove()
  //       purchaseErrorSubscription.remove()
  //       transactionSubscription?.remove()
  //     }
  //   }
  // }, [activeNewSubscriptionState, createAppleSubscription, navigation])

  const addCoupon = async () => {
    setLoading(true)
    try {
      if (isIOS && coupon !== '') {
        Linking.openURL(`https://apps.apple.com/redeem/?ctx=offercodes&id=1559404571&code=${coupon}`)
        // await presentCodeRedemptionSheetIOS()
        // setIsCouponAdded(true)
      } else {
        await getPromotionByPromoCode({ code: coupon })
        setIsCouponAdded(true)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const paySubscriptionAndTrack = async () => {
    setEvent('Cart Checkout Tapped', {
      product: `${params.membershipType} Membership`
    })
    // paySubscription({
    //   stripeProductId: membership.stripeProductId ?? '',
    //   price: currentBasePrice ?? 0,
    //   membershipPrice: membershipPrice,
    //   promoCodeId: promotionalCode?.id,
    //   membershipType: membership.type,
    //   coupon_code: coupon
    // })
  }

  const navigateAndTrackLeave = () => {
    setEvent('Purchase Cancelled', {
      drop_off_point: 'Checkout',
      product: `${params.membershipType} Membership`
    })
    router.navigate('/(root)/(tabs)/membership')
  }

  useEffect(() => {
    if (isCouponAdded) {
      if (promotionalCode?.amountOff || promotionalCode?.percentOff) {
        setToast({
          kind: 'success',
          message: 'The promo code was added'
        })
      } else {
        setCoupon('')
        Alert.alert('Not found', 'Promotional code was not found')
      }
    }
  }, [promotionalCode, isCouponAdded, setToast])

  useEffect(() => {
    if (!selectedMembership?.price) {
      setCurrentBasePrice(0)
      return
    }
    if (isCouponAdded) {
      if (promotionalCode) {
        let discount = selectedMembership.price

        if (promotionalCode.amountOff) {
          discount -= promotionalCode.amountOff
        }

        if (promotionalCode.percentOff) {
          discount -= (selectedMembership.price * promotionalCode.percentOff) / 100
        }

        // Ensure the price is not negative
        const currentPrice = Math.max(discount, 0)
        setCurrentBasePrice(currentPrice)
      } else {
        setCurrentBasePrice(selectedMembership.price)
      }
      setIsCouponAdded(false)
    }
  }, [isCouponAdded, promotionalCode?.amountOff, selectedMembership?.price])

  useFocusEffect(
    useCallback(() => {
      setPromotionalCode(null)
      setCoupon('')
      setCurrentBasePrice(membershipPrice)
    }, [setPromotionalCode, membershipPrice])
  )

  const backAction = useCallback(() => {
    router.navigate('/(root)/(tabs)/membership')
    return true
  }, [])

  useEffect(() => {
    const backHandler = BackHandler.addEventListener('hardwareBackPress', backAction)
    return () => backHandler.remove()
  }, [])

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle={'dark-content'} />
      <DS.Frame style={styles.header}>
        <TouchableOpacity onPress={() => navigateAndTrackLeave()}>
          <MaterialIcons name="keyboard-arrow-down" size={24} color="black" />
        </TouchableOpacity>
        <DS.Frame style={styles.titleContainer}>
          <DS.Text variant="Body Medium/Medium">Review Cart</DS.Text>
        </DS.Frame>
      </DS.Frame>

      <DS.Frame style={styles.productContainer}>
        <DS.Frame style={[styles.product]}>
          <AntDesign name="check-circle" size={16} color="black" />
          <Text style={styles.productText}>{`Poker Power Premium - ${capitalizeFirstLetter(
            params.membershipType?.toLowerCase() ?? ''
          )} (Monthly Subscription)`}</Text>
          <Text style={styles.productPrice}>{`$${parsedValue(Math.floor(membershipPrice))}`}</Text>
        </DS.Frame>

        <DS.Frame style={styles.promoCodeContainer}>
          <TextInput
            value={coupon}
            onChangeText={onCouponChange}
            placeholderTextColor={DS.palette['Brand/Dark Grey']}
            placeholder="Add promo code"
            style={styles.promoCodeInput}
          />
          <DS.Frame style={styles.addPromoCodeButton}>
            <TouchableOpacity disabled={loading} onPress={addCoupon}>
              {loading ? (
                <ActivityIndicator size="small" color="white" />
              ) : (
                <MaterialIcons name="add" size={24} color="white" />
              )}
            </TouchableOpacity>
          </DS.Frame>
        </DS.Frame>
      </DS.Frame>

      <View style={styles.balanceContainer}>
        <DS.Text variant="Body Large/Medium">Today's Balance</DS.Text>
        <DS.Text variant="Body Large/Regular">${parsedValue(currentBasePrice)}</DS.Text>
      </View>

      <MembershipCard isCheckout membership={selectedMembership} />

      <View style={styles.buttonContainer}>
        {isIOS ? (
          <>
            {/* <View style={{ width: '100%', alignItems: 'center', paddingBottom: 14 }}>
              <DS.Text variant="Body Large/Medium">- or -</DS.Text>
            </View> */}
            <AppleCheckout promotionalCode={promotionalCode} loading={loading} setLoading={setLoading} />
          </>
        ) : (
          <TouchableOpacity
            style={styles.checkoutButton}
            // disabled={loadingPayment}
            onPress={() => paySubscriptionAndTrack()}
          >
            <Text style={styles.checkoutText}>{currentBasePrice === 0 ? 'Subscribe' : 'Checkout'}</Text>
            {/* {loadingPayment && <ActivityIndicator size="small" color="white" />} */}
          </TouchableOpacity>
        )}
        <Text style={startStyles.bottomText} allowFontScaling={false}>
          {translate('signup.bottomText')}
          <Text
            style={startStyles.termsAndPrivacyText}
            allowFontScaling={false}
            onPress={async () => {
              const url = 'https://pokerpower.com/terms-of-service/'
              try {
                await WebBrowser.openBrowserAsync(url)
              } catch (error) {
                Linking.openURL(url)
              }
            }}
          >
            {translate('signup.termsOfUse')}
          </Text>
          {translate('signup.and')}
          <Text
            allowFontScaling={false}
            style={startStyles.termsAndPrivacyText}
            onPress={async () => {
              const url = 'https://pokerpower.com/privacy-policy/'
              try {
                await WebBrowser.openBrowserAsync(url)
              } catch (error) {
                Linking.openURL(url)
              }
            }}
          >
            {translate('signup.privacyPolicy')}
          </Text>
        </Text>
      </View>
    </SafeAreaView>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 24,
    backgroundColor: DS.palette['Brand/Cream']
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 20
  },
  headerTitle: {
    marginLeft: 10,
    fontSize: 18,
    fontWeight: 'bold'
  },
  titleContainer: {
    flex: 1,
    alignItems: 'center'
  },
  productContainer: {
    marginTop: 20
  },
  product: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  borderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: DS.palette['Brand/Dark Grey']
  },
  productText: {
    fontSize: 16,
    flex: 1,
    marginLeft: 10
  },
  productPrice: {
    fontSize: 16
  },
  promoCodeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
    borderBottomWidth: 1,
    borderBottomColor: DS.palette['Brand/Dark Grey'],
    borderTopWidth: 1,
    borderTopColor: DS.palette['Brand/Dark Grey'],
    marginLeft: 25
  },
  promoCodeInput: {
    flex: 1,
    height: 40,
    marginVertical: 8
  },
  addPromoCodeButton: {
    width: 40,
    height: 32,
    borderRadius: 24,
    backgroundColor: DS.palette['Brand/Dark Grey'],
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 10
  },
  balanceContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    backgroundColor: `${DS.palette['Global/White']}80`,
    paddingVertical: 12,
    paddingHorizontal: 24,
    marginTop: 28,
    borderRadius: 16,
    gap: 16
  },
  balanceText: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  balanceValue: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  subscriptionCard: {
    marginTop: 20,
    padding: 16,
    borderRadius: 10
  },
  subscriptionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'white'
  },
  subscriptionType: {
    fontSize: 22,
    fontWeight: 'bold',
    color: 'white',
    marginBottom: 10
  },
  features: {
    marginTop: 10
  },
  feature: {
    fontSize: 14,
    color: 'white',
    marginBottom: 5
  },
  cancelText: {
    fontSize: 14,
    color: 'white',
    marginTop: 10
  },
  checkoutButton: {
    flexDirection: 'row',
    backgroundColor: 'black',
    padding: 12,
    borderRadius: 50,
    gap: 8,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 'auto',
    marginBottom: 15
  },
  checkoutText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'white'
  },
  buttonContainer: {
    marginTop: 'auto'
  }
})

export default JoinPremiumCheckoutScreen
